<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="fellowships"
                class="elevation-1"
                disable-initial-sort
                :pagination.sync="pagination"
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.index + 1}}</td>
                <td><router-link :to="'/fellowship/'+ props.item.server + '/' + props.item.fellowshipId">{{ props.item.fellowship }}</router-link></td>
                <td>{{ props.item.serverName }}</td>
                <td><vue-numeric :value="props.item.currScore"></vue-numeric> </td>
                <td><vue-numeric :value="props.item.lastWeeksChange"></vue-numeric> </td>
            </template>

            <template slot="no-data">
                <v-alert :value="true" color="info" icon="info">
                    Sorry, nothing to display here :(
                </v-alert>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';
    import VueNumeric from 'vue-numeric';

    export default {
        name: 'elv-fellowship-ranking-table',
        components: {VueNumeric},
        props: {"fellowships": {required:true}},
        data () {
            return {
                pagination: {
                    sortBy: 'currScore',
                    descending:true,
                    rowsPerPage: 10
                },
            }
        },
        mounted() {

        },
        computed: {
            headers: {
                get: function () {
                    return [
                        {text: this.$i18n.t('site.fellowship.stats.rank'),sortable:false },
                        {
                            text: this.$i18n.t('site.common.fellowship'),
                            align: 'left',
                            sortable: false,
                            value: 'fellowship'
                        },
                        {text: this.$i18n.t('site.common.server'), value: 'serverName', width: '40'},
                        {text: this.$i18n.t('site.common.score'), value: 'currScore', sortable:true},
                        {text: this.$i18n.t('site.common.lastWeekGain'), value: 'lastWeeksChange', sortable:true},
                    ];
                }
            },
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ElvFellowshipRankingTable.vue